import { differenceInDays } from "date-fns";

export default function formatLifetime(durationMs: number) {
  if (durationMs === Infinity) {
    return "–";
  }
  const daysCount = differenceInDays(new Date(durationMs), new Date(0));
  if (daysCount < 1) {
    return "<1d";
  }
  return `${daysCount}d`;
}
